import React from 'react';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { Helmet } from 'react-helmet-async';
import CountUp from "react-countup";
function About() {

    return (
        <>
            <style>
                {
                    `
				header a{
					color:#D21677 !important;
				}
				.btn-pink{
					background:#D21677 !important;
					color:#ffff !important;
				}
				.bg-pink{
					background:#D21677 !important;
					color:#ffff !important;
				}
				.text-pink{
					color:#D21677 !important;
				}
			`
                }
            </style>
            <Helmet>
                <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company - About Us</title>
                <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                <meta property="og:title" content="Radius - About Us" />
                <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
            </Helmet>
 
            <div className="body">
                <Header />
                <div role="main" className="main">
                    <section className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7" 
                        style={{ backgroundImage: 'url(img/page-header/about-us.jpg)' }}>
                        <div className="container">
                            <div className="row mt-5">
                                <div className="col-md-12 align-self-center p-static order-2 text-center">
                                    <h1 className="text-9 font-weight-bold">About Us</h1>
                                    <span className="sub-title">The perfect choice for your next project</span>
                                </div>
                                <div className="col-md-12 align-self-center order-1">
                                    <ul className="breadcrumb breadcrumb-light d-block text-center">
                                        <li><a href="#">Home</a></li>
                                        <li className="active">Pages</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="container">

                        <div className="row pt-5">
                            <div className="col">

                                <div className="row text-center pb-5">
                                    <div className="col-md-12 mx-md-auto">
                                        <div className="overflow-hidden mb-3">
                                            <h1 className="word-rotator slide font-weight-bold text-8 mb-0 ">
                                                <span className="word-rotator-words bg-pink">
                                                    <b className="is-visible">About</b>
                                                </span>
                                                <span> Radius</span>
                                            </h1>
                                        </div>
                                        <div className="overflow-hidden mb-3">
                                            <p className="lead mb-0 ">
                                                Radius is Interior Fit Out Company in Dubai which established in 2007 and built on a legacy of uncompromising craftsmanship and world-class project management, Our divisions; Event Production, Exhibition Stand Fabrication, Interior Fit-outs, Signage, Large Format Printing & Branding are led by passionate experts in their field, With a focus on finding creative solutions on every aspect of your events, from strategic planning to finding venues and creating immersive experiences. We organize memorable events in various sectors including healthcare, technology, finance, energy, engineering… “Original concepts and impeccable execution” is what RADIUS promise. Whatever you are looking for, no matter what your event production works, exhibition, interior fit-outs, printing or signage needs are, we will be able to provide creative solutions.
                                            </p>
                                             
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3 mb-5">
                                    <div className="col-md-6 ">
                                        <h3 className="font-weight-bold text-4 mb-2">Our Mission</h3>
                                        <p>At Radius, our mission is to deliver exceptional interior fit-outs, event productions, exhibitions, and branding solutions through uncompromising craftsmanship, innovative thinking, and world-class project management. We strive to transform ideas into immersive experiences by providing creative, reliable, and high-quality solutions that exceed client expectations across every stage of execution.</p>
                                    </div>
                                    <div className="col-md-6 ">
                                        <h3 className="font-weight-bold text-4 mb-2">Our Vision</h3>
                                        <p>Our vision is to be a leading creative solutions partner in the Middle East and beyond, recognized for originality, precision, and excellence in execution. We aim to set new industry benchmarks by continuously evolving our design capabilities, embracing innovation, and creating impactful environments that inspire, engage, and leave lasting impressions.</p>
                                    </div>
                                   
                                </div>

                            </div>
                        </div>

                    </div>
 
                    <section className="section section-primary border-top-0 mb-0"
                        style={{
                            background: "linear-gradient(135deg, #D21677 0%, #ff4081 100%)",
                        }}
                    >
                        <div className="container">
                            <div className="row counters counters-sm counters-text-light">

                                <div className="col-sm-6 col-lg-4 mb-5 mb-lg-0">
                                    <div className="counter">
                                        <strong>
                                            <CountUp end={90} duration={3} suffix="+" />
                                        </strong>
                                        <label
                                            className="opacity-8 text-4 mt-1"
                                            style={{ fontWeight: 700 }}
                                        >Clients</label>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-lg-4 mb-5 mb-lg-0">
                                    <div className="counter">
                                        <strong>
                                            <CountUp end={5500} duration={3} suffix="+" />
                                        </strong>
                                        <label
                                            className="opacity-8 text-4 mt-1"
                                            style={{ fontWeight: 700 }}
                                        >Projects</label>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-lg-4 mb-5 mb-sm-0">
                                    <div className="counter">
                                        <strong>
                                            <CountUp end={18} duration={3} />
                                        </strong>
                                        <label
                                            className="opacity-8 text-4 mt-1"
                                            style={{ fontWeight: 700 }}
                                        >
                                            Years
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    );
}

export default About;
